import { types, Instance, IStateTreeNode, getRoot } from 'mobx-state-tree';
import { IRootStore } from 'RootStore';

const { model, maybeNull, number } = types;

export const TableStore = model('TabelStore', {
  startPageIndex: maybeNull(number),
}).actions((self) => ({
  setStartPageIndex(num: number) {
    self.startPageIndex = num;
  },
}));

export type ITableStore = Instance<typeof TableStore>;

export const withTableStore = (self: IStateTreeNode) => {
  return {
    views: {
      get tableStore(): ITableStore {
        return getRoot<IRootStore>(self).tableStore;
      },
    },
  };
};
